export default "/_next/static/chunks/fonts/GraphikBoldItalic-235bd40d2881b1f79296899e001907ed.otf";